import y2021 from './2021';
import y2022 from './2022';
import y2023 from './2023';
import y2024 from './2024';
import y2025 from './2025';
import y2026 from './2026';

const releaseList = [
  ...y2026,
  ...y2025,
  ...y2024,
  ...y2023,
  ...y2022,
  ...y2021
];


const data = (userInfo) => ({
  title: '변경내역',
  unrecognized_aff_ser: ['restrict_api_doc'],
  exempted_m_no : [122082],
  url: '/release',
  children: [],
  alwaysShow: true,
  data: releaseList
});

export default data;